import { jsx as _jsx } from "react/jsx-runtime";
import { useEffect, useState } from 'react';
import { Pagination as AntdPagination } from 'antd';
const Pagination = ({ data, handleOnPageChange }) => {
    const onChange = (currentPage, pageSize) => {
        handleOnPageChange(currentPage, pageSize);
    };
    const [width, setWidth] = useState(window.innerWidth);
    function handleWindowSizeChange() {
        setWidth(window.innerWidth);
    }
    useEffect(() => {
        window.addEventListener('resize', handleWindowSizeChange);
        return () => {
            window.removeEventListener('resize', handleWindowSizeChange);
        };
    }, []);
    return (_jsx(AntdPagination, { size: width <= 1150 ? "small" : "default", total: data === null || data === void 0 ? void 0 : data.dataSize, showSizeChanger: true, showQuickJumper: true, showTotal: width <= 1150 ? (total) => `` : (total) => `Total ${total} items`, onChange: onChange, current: data === null || data === void 0 ? void 0 : data.currentPage }));
};
export default Pagination;
